module.exports = __webpack_public_path__ + "img/stick_activites_rando_pedestre.5a7c79a4.svg";